<template>
  <div class="d-flex flex-wrap wrapper">
    <div v-for="tagId in order.tagIds" :key="tagId" class="tags-wrapper">
      <template v-if="order.tags[tagId]">
        <div class="tags" :style="{backgroundColor: order.tags[tagId].color}">
            <p class="text">{{order.tags[tagId].title}}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'OrderTags',
  props: {
    order: {
      required: true,
      type: Object
    }
  }
}
</script>

<style scoped>
  .wrapper {
    margin-top: 5px;
  }
  .tags-wrapper {
    width: 100%;
    max-width: fit-content;
  }
  .tags {
    cursor: default;
    border-radius: 16px;
    display: flex;
    align-items: center;
    height: 20px;
    font-size: 10px;
    padding: 8px 12px;
    margin: 0 2px 2px 0;
    box-sizing: border-box;
    max-width: fit-content;
  }

  .text {
    color: white!important;
    font-weight: bold;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin: 1px;
  }
</style>